import { combineReducers } from '@reduxjs/toolkit';
import { baseAPI } from 'api/base';

import authReducer from 'features/auth/authSlice';
import { loading } from 'features/loading';
import modal from 'features/modal/index.js';
import transactions from './transactions';
import financeRequests from './financeRequests';
import ProgramsCompanies from './programsCompanies';

const appReducer = combineReducers({
	[baseAPI.reducerPath]: baseAPI.reducer,
	auth: authReducer,
	modal,
	loading,
	transactions,
	financeRequests,
	ProgramsCompanies
});

const rootReducer = (state, action) => {
	if (action.type === 'auth/logout') {
		state = {};
	}
	return appReducer(state, action);
};

export default rootReducer;
